import React, {Component} from "react";
import "./tableToolBar.scss";
import {Button} from "antd";
import CmSearchInput from "../../../../../components/CmSearchInput/CmSearchInput";
import BaseComponent from "../../../../../base/BaseComponent";

export default class TableToolBar extends BaseComponent {

    render() {
        const {searchValue, onSearch, onSearchValueChange} = this.props;
        return (
            <div className="TableToolBar">
                <div className="TableToolBar-left">
                    <Button type="primary" onClick={() => this.props.showPermissionEdit()}>添加权限</Button>
                </div>
                <div className="TableToolBar-right">
                    <CmSearchInput
                        searchValue={searchValue}
                        onSearch={onSearch}
                        onSearchValueChange={onSearchValueChange}
                        placeholder="请输入权限名称/编码"
                    />
                </div>
            </div>
        );
    }
}


